import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { bindActionCreators } from 'redux'
import { push } from 'react-router-redux'
import { SubmissionError } from 'redux-form'
import LoadingProgress from '../components/LoadingProgress'

import Box from '../components/Box'
import ErrorMessage from '../components/ErrorMessage'
import { fetchUser, updateUser, addUser } from '../actions/users'
import { renderInputField, renderSelectField } from '../utils/forms'

class UserEditForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = { loaded: false, isEditing: false }
    this.submit = this.submit.bind(this)
  }

  componentDidMount() {
    const { editingUser, users, fetchUser, match } = this.props

    if (editingUser) {
      this.setState({ loaded: true, isEditing: true })
    } else if (match && match.params && match.params.id) {
      this.setState({ isEditing: true })
      if (!users.user) {
        fetchUser(match.params.id)
      } else {
        this.setState({ loaded: true })
      }
    } else {
      this.setState({ loaded: true, isEditing: false })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.loaded && nextProps.users.user) {
      this.setState({ loaded: true })
    }
  }

  submit(props) {
    const { updateUser, addUser, editingUser, onSubmit } = this.props
    const { isEditing } = this.state

    return new Promise((resolve, reject) => {
      const action = isEditing
        ? updateUser(editingUser._id, props)
        : addUser(props)

      action.then((response) => {
        if (onSubmit) {
          onSubmit()
        } else {
          this.props.push(`/users/${response.response._id}`)
        }
        resolve()
      }).catch((error) => {
        reject(new SubmissionError({
          _error: error.message || 'Error saving user',
          ...error.fields
        }))
      })
    })
  }

  render() {
    const { users, error, pristine, submitting, handleSubmit, editingUser, onCancel } = this.props
    const { loaded, isEditing } = this.state

    if (!loaded) {
      if (users.error) {
        return <ErrorMessage message={users.error.message} />
      }
      return <LoadingProgress />
    }

    return (
      <form onSubmit={handleSubmit(this.submit)}>
        <Box title={isEditing ? 'Editar Administrador' : 'Nuevo Administrador'} icon="user">
          <Field name="fullname"
                 type="text"
                 component={renderInputField}
                 label="Nombre"/>
          <Field name="email"
                 type="text"
                 component={renderInputField}
                 label="E-mail"/>
          <Field name="password"
                 type="password"
                 component={renderInputField}
                 label="Password"/>
          <Field name="type"
                 component={renderSelectField}
                 label="Tipo">
            <option value="">Selecciona un tipo...</option>
            <option value="PRODUCCION">Producción</option>
            <option value="PROYECTOS">Proyectos</option>
            <option value="SAT1">SAT 1</option>
            <option value="SAT2">SAT 2</option>
            <option value="PROVEEDOR">Proveedor</option>
            <option value="CONTABILIDAD">Contabilidad</option>
            <option value="MASTER">Master</option>
            <option value="COMERCIAL">Comercial</option>
          </Field>
        </Box>
        {error && <div className="alert alert-danger">{error}</div>}
        <div className="d-flex justify-content-between">
          {onCancel && (
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onCancel}
              disabled={submitting}
            >
              Cancelar
            </button>
          )}
          <button className="btn text-white bg-vw-light ml-auto" type="submit"
                  disabled={pristine || submitting}>
            {submitting ? 'Guardando...' : 'Guardar'}
          </button>
        </div>
      </form>
    )
  }
}

UserEditForm = reduxForm({
  form: 'UserEditForm',
  enableReinitialize: true,
})(UserEditForm)

const mapStateToProps = (state, ownProps) => ({
  users: state.users,
  initialValues: ownProps.editingUser ? {
    fullname: ownProps.editingUser.fullname || '',
    email: ownProps.editingUser.email || '',
    password: '',
    type: ownProps.editingUser.type || '',
  } : {
    fullname: '',
    email: '',
    password: '',
    type: '',
  }
})

const mapDispatchToProps = dispatch => ({
  fetchUser: bindActionCreators(fetchUser, dispatch),
  updateUser: bindActionCreators(updateUser, dispatch),
  addUser: bindActionCreators(addUser, dispatch),
  push: bindActionCreators(push, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(UserEditForm)

